import { NotificationItemId } from "@multiweb/types/contracts";

export type NotificationListComponentProps = {
    /** Identifikátory notifikačních položek. */
    notificationItemIds: readonly NotificationItemId[];
    /** Příznak, zda jsou dostupné další notifikační položky. */
    hasNextPage: boolean;
    /** Příznak, zda se aktuálně načítá stránka notifikačních položek. */
    isNextPageLoading: boolean;
    /** Funkce pro načtení další stránky notifikačních položek. */
    loadNextPage: () => void;
    /** Příznak, zda vybraná notifikační skupina neobsahuje notifikační položky. */
    emptyNotificationGroup: boolean;
    /** Nadpis sekce menu. */
    title: string | undefined;
    /** Index zaměřené položky. */
    focusedItemIndex: number | undefined;
};
